import axios from 'axios'

export default axios.create({
    baseURL: process.env.VUE_APP_ASSETS_URL + 'v2/',
    headers: {},
    crossDomain: true
})
